const LIST_QUERY = `
  query ListNotifications($paginationParams: PaginationInput!) {
    listNotifications(pagination: $paginationParams) {
      objects {
        timestamp
        level
        source
        message
      }
      totalRows
    }
  }
`

const notificationQueries = {
  methods: {
    async listNotificationsQuery(paginationParams) {
      try {
        const _result = await this.graphQuery(LIST_QUERY, {paginationParams})
        const {objects: alertsList, totalRows} = _result.listNotifications
        return {alertsList, totalRows}
      } catch (error) {
        throw new Error(error)
      }
    },
  },
}

export default notificationQueries
